module.exports = __webpack_public_path__ + "img/1.90a2c13e.png";